import { shallowRef, watch } from 'vue';
import { defineStore } from 'pinia';
import { useAuthStore } from './auth.store';

// Home owns the prompt; native notifications wait until the patient finishes it.
export const useMicroEducationStore = defineStore('microEducationStore', () => {
  const auth = useAuthStore();
  const open = shallowRef(false);

  watch(
    () => auth.authStateVersion,
    () => {
      open.value = false;
    },
    { flush: 'sync' },
  );

  return { open };
});
